import { GlobalWorkerOptions } from 'pdfjs-dist';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Side-effect module: point pdf.js at the bundled worker. Import this once
// before calling getDocument().
GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
